import { Routing } from "./Routing";


function App() {
  console.log("DEBUG");
  return (
   <Routing/>
  );
}

export default App;
